import React from 'react';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import { DateRange } from '@mui/icons-material';
import { format } from 'date-fns';

interface DateRangeSelectorProps {
  value: { start: Date; end: Date };
  onChange: (range: { start: Date; end: Date, range: number }) => void;
}

const PRESET_RANGES = [
  { label: 'Last 1 day', days: 1 },
  { label: 'Last 7 days', days: 7 },
  { label: 'Last 30 days', days: 30 },
  { label: 'Last 90 days', days: 90 },
  { label: 'Last 6 months', days: 180 },
  { label: 'Last year', days: 365 },
];

export const DateRangeSelector: React.FC<DateRangeSelectorProps> = ({ value, onChange }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectRange = (days: number) => {
    const end = new Date();
    const start = new Date(end.getTime() - days * 24 * 60 * 60 * 1000);
    onChange({ start, end, range: days });
    handleClose();
  };

  return (
    <Box>
      <Button
        variant="outlined"
        startIcon={<DateRange />}
        onClick={handleClick}
        sx={{
          borderColor: 'divider',
          color: 'text.secondary',
          '&:hover': {
            borderColor: 'primary.main',
            color: 'primary.main',
          },
        }}
      >
        <Typography variant="body2">
          {format(value.start, 'MMM d, yyyy')} - {format(value.end, 'MMM d, yyyy')}
        </Typography>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {PRESET_RANGES.map((range) => (
          <MenuItem
            key={range.days}
            onClick={() => handleSelectRange(range.days)}
            selected={
              value.start.getTime() ===
              new Date(value.end.getTime() - range.days * 24 * 60 * 60 * 1000).getTime()
            }
          >
            {range.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}; 